if (jQuery('body').hasClass('single-product')) {
  //common functions declaration
  let showSpinner = function () {
    spinner.show();
    jQuery('.apply_voucher').attr('disabled', true);

  }

  /**
   * Checks if the current device is a mobile device
   * @returns {boolean}
   */
  let isMobile = function(){
    var isMobile = window.matchMedia('only screen and (max-width: 760px)');
    return isMobile.matches ? true : false
  }
  /**
   * If the device is mobile, the screen will auto-scroll to user details form
   */
  let mobileScroll = function () {
    if (isMobile()){ // Scroll down automatically to user details
      $('html, body').animate({ scrollTop: $('.woocommerce-billing-fields__field-wrapper').offset().top-250 }, 1000);
    }
  }

  let hideSpinner = function () {
    spinner.hide();
    jQuery('.apply_voucher').removeAttr('disabled');
  }

  let displayVoucherBenefitsClubError = function () {
    jQuery('#voucherBenefitsClubsError').parent().show();
    jQuery('#voucherBenefitsClubsError').fadeIn();
  }

  let displayWrongVoucherError = function () {
    jQuery('#wrongVoucherError').parent().show();
    jQuery('#wrongVoucherError').fadeIn();
  }

  let hideVoucherErrors = function () {
    jQuery('.voucher-error-messages').hide();

  }

  let spinner = $('<div></div>', {'class': 'customSpinner'}); //spinner declaration
  $(spinner).appendTo('.checkout_voucher .form-row-last');
  spinner.hide();

  //display the activate voucher button
  jQuery('.showVoucherButton').on('click', (event) => {
    event.preventDefault();
    jQuery('div.checkout_voucher.woocommerce-form-voucher').toggle()
  })

  /**
   * Function responsible for checking the amount field after voucher/coupon apply.
   * If the value is equal to 0, The place order button will show specific text, otherwise
   * it will show the regular message
   *
   */
  let checkoutButtonText = function () {

    let finalPrice  = cartTotal();
    if (finalPrice<=0){
      jQuery('#place_order').text('אישור הזמנה');
    }
  }

  /**
   * function receives the data of the checkCouponThenVoucher function and checks if the amount to pay is 0
   * if it is 0 , change the page structure so that the user will not see the details below and they will
   * be filled automatically. if there's still amount to pay the page behaviour will be default
   * @param data
   */
  let checkVoucherBenefitsClubAdminPanel = function (data) {

    let productID = jQuery('.productID').text();
    if (data.vouchersInUse.voucherDetails.product_id === productID && data.vouchersInUse.voucherDetails.benefits_club_admin_panel && data.vouchersInUse.voucherDetails.benefits_club_admin_panel === true){
      jQuery('.row.moreDetailsFormWrapper').css('display', 'none'); // hide the text above ToS toggle
      jQuery('.woocommerce-billing-fields').css('display', 'none'); // hide the input fields
      jQuery('#billing_first_name').val(data.vouchersInUse.voucherDetails.benefits_club); // first name
      jQuery('#billing_last_name').val(data.vouchersInUse.voucherDetails.benefits_club); // last name
      jQuery('#billing_email').val('info@mly.co.il'); // email
      jQuery('#billing_phone').val('052-0000000');// phone
      return true;
    }
    return false;
  }

  let cartTotal = function () {

    let finalPrice = jQuery('.totalNumber .woocommerce-Price-amount.amount').first().text();
    return parseInt(finalPrice.match(/\d+/));
  }

  $('.input-text.qty.text.select2-hidden-accessible').on('change', 'select', function (e) {
    let val = $(e.target).val();
    let text = $(e.target).find('option:selected').text(); //only time the find is required
    let name = $(e.target).attr('name');
    console.log(val,text,name)
  })

  let displayVoucherSuccess = function () {
    jQuery('.popupWrapper').fadeIn();
    jQuery('#voucherSuccessMobile').parent().show();
    jQuery('#voucherSuccessMobile').fadeIn();
  }

  /**
   * handling voucher and coupon validate function via ajax request
    Important - Currently when using vouchers, and then applying coupon ,
    the coupon discount results from total number of tickets and not from the (number of tickets - number of used coupons)
   handling voucher and coupon validate function via ajax request
   */
  jQuery('.apply_voucher').on('click', (event) => {
    event.preventDefault();
    showSpinner();

    let voucherCode = jQuery('input#voucher_code').val();
    let productID = jQuery('.productID').text();
    jQuery.post('/wp-json/checkCouponThenVoucher/v1/checkCouponThenVoucher', {
      voucherCode: voucherCode,
      productID: productID,
    })
      .done(function (data) {
        hideSpinner();
        if(data.isApplied === true){
          appliedCouponUpdateFields(data);
          appliedCoupon();
        }
        else if (data.vouchersInUse && data.vouchersInUse.voucherDetails && data.vouchersInUse.voucherDetails.product_id && data.vouchersInUse.voucherDetails.quantity > 0) {
          appliedVoucherUpdateFields(data);
          let voucherBenefitsClubAdminPanel = checkVoucherBenefitsClubAdminPanel(data);
          let finalPrice = cartTotal();
          if (finalPrice>0)
          {
            if (voucherBenefitsClubAdminPanel) { // if true, voucher benefits club order with more tickets than vouchers
              displayVoucherBenefitsClubError(); // show message that used vouchers need to be the same number as ordered tickets
            }
            else { // not voucher benefits club, no need to show errors, just display the voucher success popup
              hideVoucherErrors();
              displayVoucherSuccess();
            }
          }
          else { //order total is 0, // not voucher benefits club, no need to show errors, just display the voucher success popup and change text of the place order button
            hideVoucherErrors();
            displayVoucherSuccess();
            checkoutButtonText();
          }
        }else{ // voucher ajax call completed successfully but no valid voucher returned, show error
          displayWrongVoucherError();
        }
      }).fail(function () { // voucher ajax call failed, show error
      hideSpinner();
      displayWrongVoucherError();
    });
  })

  jQuery('#voucher_code').on('input', function () { // update voucher code to be included in order
    jQuery('#billing_vouchers').val(jQuery(this).val())
  })

  /**
   * Function responsible for showing messages relevant to apply coupon
   */
  let appliedCoupon = function () {
    hideVoucherErrors();
    displayVoucherSuccess();
    checkoutButtonText();
  }

  /**
   * Function receives the returned data from the ajax call to apply voucher and updates the fields in the page
   * according to the returned results
   * @param data
   */
  let appliedVoucherUpdateFields = function (data) {
    jQuery('input#billing_vouchers_in_use').val(JSON.stringify(data.vouchersInUse));
    jQuery('.totalNumber span.woocommerce-Price-amount.amount').text('₪' + data.total);
    jQuery('#voucherSuccessMobile .woocommerce-Price-amount.amount').text('₪' + data.total);
  }

  /**
   * Function receives the returned data from the ajax call to apply coupon and updates the fields in the page
   * according to the returned results
   * @param data
   */
  let appliedCouponUpdateFields = function (data) {
    jQuery('.totalNumber span.woocommerce-Price-amount.amount').text('₪' + data.total);
    jQuery('#voucherSuccessMobile .woocommerce-Price-amount.amount').text('₪' + data.total);
  }

  /**
   * Function closes the success popup and shows the user the customer details (phone,email,name) fields
   */
  jQuery('.popup-continue-button').on('click', (event) => {
    event.preventDefault();
    jQuery('.voucherPopup').fadeOut()
    jQuery('.popupWrapper').fadeOut()
    jQuery('#continueButton').trigger('click'); // automatically open the client details window below
    mobileScroll();
  })
}



// WEBPACK FOOTER //
// ./scripts/util/vouchers.js